<template>
  <cadastro-base
    :salvar="salvarOuEditar"
    :cancelar-cadastro="fechar"
  >
    <template slot="conteudo">
      <b-row>
        <!-- Empresa (select) -->
        <b-col
          cols="12"
          md="6"
        >
          <!-- Espaço para o select de empresa -->
          <empresa-select
            v-model="empresa"
            :disabled="disabledGeral"
          />
        </b-col>

        <!-- Tipo (enum) -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Tipo de Documento/ Licença">
            <b-form-select
              v-model="documentoLicenca.tipo"
              :options="tiposDocumentoLicenca"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Número -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Número">
            <b-form-input
              v-model="documentoLicenca.numero"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Status (enum) -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Status">
            <b-form-select
              v-model="documentoLicenca.status"
              :options="statusDocumentoLicenca"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Observações -->
        <b-col cols="12">
          <b-form-group label="Observação">
            <b-textarea
              v-model="documentoLicenca.observacoes"
              :disabled="disabledObservacao || disabledGeral"
              style="border-radius: 8px;"
            />
          </b-form-group>
        </b-col>

        <!-- Data de Emissão -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Data de Emissão">
            <b-form-datepicker
              v-model="documentoLicenca.dataEmissao"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Data de Vencimento -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Data de Vencimento">
            <b-form-datepicker
              v-model="documentoLicenca.dataVencimento"
              :disabled="disabledGeral"
            />
          </b-form-group>
        </b-col>

        <!-- Não notificar vencimento -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group>
            <b-form-checkbox
              v-model="documentoLicenca.naoNotificarVencimento"
              :disabled="disabledGeral"
            >
              Não notificar sobre o vencimento
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </cadastro-base>
</template>
<style lang="scss" scoped>

</style>
<script>
import apiDocumentoLicenca from '@/app-modulo/comuns/documentos-e-licencas/shared/services/api'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'
import { getUserData, permitidoAcessarRecursoSeNaoAdmin } from '@/auth/utils'

export default {
  name: 'DocumentoLicenca',
  components: {
    CadastroBase: () => import('@/shared/components/cadastro-base/CadastroBase.vue'),
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
  },
  data() {
    return {
      tiposDocumentoLicenca: [],
      statusDocumentoLicenca: [
        { value: '1', text: 'Ativo' },
        { value: '2', text: 'Inativo' },
        { value: '3', text: 'Vencido' },
        { value: '4', text: 'Em Processo' },
      ],
      documentoLicenca: {
        empresaId: null,
        tipo: null,
        numero: '',
        status: null,
        observacoes: '',
        dataEmissao: null,
        dataVencimento: null,
        naoNotificarVencimento: false,
      },
      empresa: null,
      disabled: false,
      disabledInputs: false,
      disabledObservacao: false,
      disabledGeral: false,
      loadingDocumentoLicenca: false,
      mensagem: 'Carregando...',
    }
  },
  created() {
    apiDocumentoLicenca.getTiposDocumentoLicenca()
      .then(response => {
        this.tiposDocumentoLicenca = response.data.map(tipo => ({
          value: tipo.id,
          text: tipo.nome,
        }))
      })
      .catch(() => {
        this.$erro('Erro ao buscar tipos de documento/licença')
      })

    this.getDocumentoLicenca()
    this.disabledCampos()
  },
  methods: {
    getDocumentoLicenca() {
      const { id } = this.$route.params
      if (id) {
        apiDocumentoLicenca.GetDocumentoLicencaById(id)
          .then(payload => {
            this.documentoLicenca = payload.data

            apiEmpresa.getEmpresa(this.documentoLicenca.empresaId)
              .then(response => {
                this.empresa = response.data
              })
          })
          .catch(() => {
            this.$erro('Não foi possível buscar o documento/licença')
            this.fechar()
          })
      }
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'documentos-e-licencas' })
      } else {
        this.$router.go(-1)
      }
    },
    salvarOuEditar() {
      this.documentoLicenca.empresaId = this.empresa.id
      if (this.$route.path.includes('/novo')) {
        apiDocumentoLicenca.createDocumentoLicenca(this.documentoLicenca)
          .then(() => {
            this.fechar()
            this.$sucesso('Documento/Licença salvo com sucesso!')
          })
          .catch(() => {
            this.$erro('Ocorreu um erro ao salvar')
          })
      } else {
        apiDocumentoLicenca.update(this.documentoLicenca.id, this.documentoLicenca)
          .then(() => {
            this.fechar()
            this.$sucesso('Documento/Licença atualizado com sucesso!')
          })
          .catch(() => {
            this.$erro('Ocorreu um erro ao atualizar')
          })
      }
    },
    disabledCampos() {
      const userData = getUserData()
      const permissaoUpdate = permitidoAcessarRecursoSeNaoAdmin('documentoLicenca', 'update')
      if (!userData.admin && !permissaoUpdate) {
        this.disabledObservacao = false
        this.disabledGeral = true
      }
    },
  },
}
</script>
